import React from "react";

// why: 회사 소식을 게시할 독립 페이지 스켈레톤

const SupportNews = () => {
  return (
    <main className="page-sub">
      <h2>회사소식</h2>
    </main>
  );
};

export default SupportNews;


